import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues } from './formData';
import { Param } from '../../../../../shared/types/param';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParamByCode } from '../../../../../services/param.service';

export const useFraudModeFilters = (onFilter?: (data: Param) => void) => {
    const [typesPqr, setTypes] = useState<ISelect[]>([]);

    const onSubmit = (data: Param) => {
        if (onFilter) onFilter(data || {});
    };

    useEffect(() => {
        const fetchParams = async () => {
            try {
                const paramCodes = [
                    `${ParamEnum.PQR_TYPE}_QEX`,
                    `${ParamEnum.PQR_TYPE}_QOR`,
                ];
                const results = await Promise.all(
                    paramCodes.map((code) => asyncGetParamByCode(code))
                );
                setTypes(
                    results.filter(
                        (item): item is ISelect => item !== undefined
                    )
                );
            } catch (error) {
                console.error('Failed to fetch params:', error);
            }
        };
        fetchParams();
    }, []);

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
        typesPqr,
    };
};
